import { render, staticRenderFns } from "./groundlights_task_add.vue?vue&type=template&id=21e04a08&"
import script from "./groundlights_task_add.vue?vue&type=script&lang=ts&"
export * from "./groundlights_task_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports